import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ElmarknadAi = lazy(() => import("@/pages/ElmarknadAi"));

export const Route = createFileRoute("/ai")({
  // seoHead ger samma titel/beskrivning plus canonical och og:url, som saknades.
  head: () =>
    seoHead("/ai", {
      title: "Elmarknad AI » Chatta om elpriser & elavtal | Elmarknad.se",
      description:
        "Ställ frågor om elpriser, elavtal och elmarknaden i en AI-chatt. Skapa konto för att spara dina konversationer.",
    }),
  component: () => <ElmarknadAi />,
});
